<template>
  <div class="hcl-form-element-checkboxes">
    <template v-if="props.definitionField.field.render === 'grid'">
      <template v-for="(row, index) in mapLookupToCheckboxes" :key="index">
        <hcl-form-input-checkboxes :checkboxes="row" orientation="horizontal" :width="columnWidthCheckboxes"
          :value="props.dataField.value" :disabled="isReadOnly(props.definitionField.field)"
          @hcl-form-input-checkboxes-changed="updateDataField" :widget="props.definitionField.field.widget?.widget"
          v-bind="generateDataAttributes" />
      </template>
    </template>
    <template v-else>
      <hcl-form-input-checkboxes :checkboxes="mapLookupToCheckboxes"
        :orientation="props.definitionField.field.render === 'inline' ? 'horizontal' : 'vertical'"
        :width="columnWidthCheckboxes" :value="props.dataField.value"
        :disabled="isReadOnly(props.definitionField.field)" @hcl-form-input-checkboxes-changed="updateDataField"
        :widget="props.definitionField.field.widget?.widget" v-bind="generateDataAttributes" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useElement } from '@/components/FormElement/element'

import HclFormInputCheckboxes from '@/components/FormInputCheckboxes/FormInputCheckboxes.vue'

interface Props {
  definitionField: any
  dataField: any
  dataLookup: any
  readOnly?: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined,
  readOnly: undefined
})

const { isReadOnly, mapLookupToCheckboxes, columnWidthCheckboxes, generateDataAttributes } = useElement(props)

const updateDataField = (evt) => {
  if (evt.checked) {
    props.dataField.value.push(evt.value)
  } else {
    if (props.dataField.value.includes(evt.value)) {
      const index = props.dataField.value.indexOf(evt.value)
      props.dataField.value.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.hcl-form-element-checkboxes {
  width: 100%;
}
</style>
